export const translationDE = {
  translation: {
    navBar: {
      title: {
        calendar: "Daten wählen",
        accommodation: "Unterkunft",
        extras: "Extras",
        summary: "Übersicht",
        details: "Details",
        payment: "Zahlung",
        success: "Bestätigung",
      },
    },
    cart: {
      title: {
        calendar: "Zur Unterkunft",
        accommodation: "Weiter zu den Extras",
        extras: "Buchung überprüfen",
        summary: "Details eingeben",
        details: "Weiter zur Zahlung",
        payment: "Buchung abschließen",
      },
      selectArrivalDate: "Bitte wähle ein Anreisedatum",
      selectDepartureDate: "Bitte wähle ein Abreisedatum",
      priceFrom: "Ab",
    },
    weekDays: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    months: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Mär",
      "Apr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dez",
    ],
    accommodation: {
      AMS: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Dein eigener privater Hub für bis zu 2 Reisende mit einem Kingsize-Bett. Perfekt für Alleinreisende, Freunde oder Paare, die Wert auf Komfort legen.",
          description:
            "Dein eigener privater Hub für bis zu 2 Reisende mit einem Kingsize-Bett. Perfekt für Alleinreisende, Freunde oder Paare, die Wert auf Komfort legen.",
          imagePath: "/assets/images/accomodation/hub_AMS/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Unser Hub ist eine L-förmige Kapsel ",
            },
            { src: "see_the_top_hub.jpg", alt: "Oberen Hub ansehen " },
            { src: "inside_the_top_hub.jpg", alt: "Im oberen Hub " },
            { src: "see_the_bottom_hub.jpg", alt: "Unteren Hub ansehen " },
            { src: "inside_the_bottom_hub.jpg", alt: "Im unteren Hub " },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Entspanne in deinem Kingsize-Bett ",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Ja, du kannst im Bett aufrecht sitzen ",
            },
            {
              src: "play_your_music_with_bluetooth.jpg",
              alt: "Spiele deine Musik über Bluetooth ab ",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gehe in unseren Kimonos zu den Duschen ",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrenbadezimmer " },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Erfrische dich unter der Regendusche ",
            },
            { src: "women_s_bathroom.jpg", alt: "Damenbadezimmer " },
            { src: "hair_&_makeup_area.jpg", alt: "Haar- & Make-up-Bereich " },
          ],
        },
        howManyTravellers: {
          title: "Wie viele Reisende?",
          content:
            "Alle unsere Unterkünfte sind mit gemütlichen Betten, stimmungsvoller Beleuchtung und moderner Technik ausgestattet. Die Frage ist nur: Wie möchtest du wohnen? <br /><br />Unsere Hubs sind ideal für Alleinreisende sowie für Paare oder Freunde, die Privatsphäre und eine gemütliche Atmosphäre schätzen.<br /><br />Wählen Sie 1 bis 4 Reisende aus, um die Preisänderung zu sehen. ",
        },
        addAnotherAccomodation: {
          title: "Hub hinzufügen",
          hub: {
            title: "Hub",
            description:
              "Privater Hub mit Kingsize-Bett – perfekt für einen oder zwei Reisende.",
          },
        },
      },
      CPH: {
        tags: ["Sauna vor Ort "],
        hub: {
          title: "Hub",
          excerpt:
            "Dein eigener privater Hub für bis zu 2 Reisende mit einem Kingsize-Bett. Perfekt für Alleinreisende, Freunde oder Paare, die Wert auf Komfort legen.",
          description:
            "Dein eigener privater Hub für bis zu 2 Reisende mit einem Kingsize-Bett. Perfekt für Alleinreisende, Freunde oder Paare, die Wert auf Komfort legen.",
          imagePath: "/assets/images/accomodation/hub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Unser Hub ist eine L-förmige Kapsel ",
            },
            { src: "see_the_top_hub.jpg", alt: "Oberen Hub ansehen " },
            { src: "inside_the_top_hub.jpg", alt: "Im oberen Hub " },
            { src: "see_the_bottom_hub.jpg", alt: "Unteren Hub ansehen " },
            { src: "inside_the_bottom_hub.jpg", alt: "Im unteren Hub " },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Entspanne in deinem Kingsize-Bett ",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gehe in unseren Kimonos zu den Duschen ",
            },
            { src: "hallway.jpg", alt: "Flur " },
            { src: "men_s_bathroom.jpg", alt: "Herrenbadezimmer " },
            { src: "women_s_bathroom.jpg", alt: "Damenbadezimmer " },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Kostenlose Rituals-Pflegeprodukte ",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Schwitze in unserer Sauna ",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Gleiche Größe wie ein Hub, aber in 2 Einzelmatratzen mit getrennten Decken und einer Trennwand unterteilt. Ideal für 2 Personen, die ihren eigenen Bereich wollen. Toll für Freunde oder Geschwister. ",
          description:
            "Gleiche Größe wie ein Hub, aber in 2 Einzelmatratzen mit getrennten Decken und einer Trennwand unterteilt. Ideal für 2 Personen, die ihren eigenen Bereich wollen. Toll für Freunde oder Geschwister. ",
          imagePath: "/assets/images/accomodation/twinHub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Unser Hub ist eine L-förmige Kapsel ",
            },
            { src: "inside_the_top_twin_hub.jpg", alt: "Im oberen Twin Hub " },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Im unteren Twin Hub ",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 Einzelmatratzen mit Trennwand ",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrenbadezimmer " },
            { src: "women_s_bathroom.jpg", alt: "Damenbadezimmer " },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Kostenlose Rituals-Pflegeprodukte ",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Schwitze in unserer Sauna ",
            },
          ],
        },
        room: {
          title: "Quad Room ",
          excerpt:
            "Brauchst du mehr Platz? Das Quad Room bietet Platz für bis zu 4 Reisende. Ideal für Freunde oder Familien. Mit privatem Badezimmer. Auch für Gäste mit Behinderungen geeignet. ",
          description:
            "Brauchst du mehr Platz? Das Quad Room bietet Platz für bis zu 4 Reisende. Ideal für Freunde oder Familien. Mit privatem Badezimmer. Auch für Gäste mit Behinderungen geeignet. ",
          imagePath: "/assets/images/accomodation/quadRoom_CPH/",
          images: [
            {
              src: "quad_room_with_4_bunk_beds.jpg",
              alt: "Quad Room mit 4 Etagenbetten ",
            },
            {
              src: "quad_room_with_a_double_bed_and_2_bunks.jpg",
              alt: "Quad Room mit Doppelbett und 2 Etagenbetten ",
            },
            { src: "private_bathroom.jpg", alt: "Privates Badezimmer " },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Erfrische dich unter der Regendusche ",
            },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Kostenlose Rituals-Pflegeprodukte ",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Schwitze in unserer Sauna ",
            },
          ],
        },
        howManyTravellers: {
          title: "Wie viele Reisende?",
          content:
            'Alle unsere Unterkünfte bieten gemütliche Betten, stimmungsvolles Licht und einen Hauch von Technik. Die einzige Frage ist: Wie übernachtest du am liebsten? <ul className="list-disc p-4"><li>Allein oder als Paar unterwegs und Lust auf Privatsphäre? → Wähle einen Hub.</li><li>Zusammen reisen, aber getrennte Betten bevorzugt (Freunde/Kollegen)? → Ein Twin Hub ist perfekt.</li><li>Auf der Suche nach einem geräumigeren Zimmer mit eigenem Bad? → Wähle ein Quad Room.</li></ul>Egal, wofür du dich entscheidest, du wirst gut schlafen.<br />Wähle 1 oder 2 Gäste, um den Preis zu sehen. ',
        },
        addAnotherAccomodation: {
          title: "Weitere Unterkunft hinzufügen",
          hub: {
            title: "Hub",
            description:
              "Private Hub mit Kingsize-Bett – perfekt für einen oder zwei Reisende.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Private Hub mit zwei Einzelbetten und Trennwand – ideal für Freunde oder Geschwister. ",
          },
          room: {
            title: "Room ",
            description:
              "Privatzimmer mit Etagenbetten und eigenem Bad – perfekt für bis zu vier Personen. ",
          },
        },
      },
      RKV: {
        tags: ["Hot Tub vor Ort "],
        hub: {
          title: "Hub",
          excerpt:
            "Dein eigener privater Hub für bis zu 2 Reisende mit einem Kingsize-Bett. Perfekt für Alleinreisende, Freunde oder Paare, die Wert auf Komfort legen.",
          description:
            "Dein eigener privater Hub für bis zu 2 Reisende mit einem Kingsize-Bett. Perfekt für Alleinreisende, Freunde oder Paare, die Wert auf Komfort legen.",
          imagePath: "/assets/images/accomodation/hub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Unser Hub ist eine L-förmige Kapsel ",
            },
            { src: "see_the_top_hub.jpg", alt: "Oberen Hub ansehen " },
            { src: "inside_the_top_hub.jpg", alt: "Im oberen Hub " },
            { src: "see_the_bottom_hub.jpg", alt: "Unteren Hub ansehen " },
            { src: "inside_the_bottom_hub.jpg", alt: "Im unteren Hub " },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Entspanne in deinem Kingsize-Bett ",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Ja, du kannst im Bett aufrecht sitzen ",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gehe in unseren Kimonos zu den Duschen ",
            },
            { src: "women_s_bathroom.jpg", alt: "Damenbadezimmer " },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Kostenlose Rituals-Pflegeprodukte ",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrenbadezimmer " },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Entspanne in unserem Hot Tub auf dem Dach ",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Gleiche Größe wie ein Hub, aber in 2 Einzelmatratzen mit getrennten Decken und einer Trennwand unterteilt. Ideal für 2 Personen, die ihren eigenen Bereich wollen. Toll für Freunde oder Geschwister. ",
          description:
            "Gleiche Größe wie ein Hub, aber in 2 Einzelmatratzen mit getrennten Decken und einer Trennwand unterteilt. Ideal für 2 Personen, die ihren eigenen Bereich wollen. Toll für Freunde oder Geschwister. ",
          imagePath: "/assets/images/accomodation/twinHub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Unser Hub ist eine L-förmige Kapsel ",
            },
            { src: "inside_the_top_twin_hub.jpg", alt: "Im oberen Twin Hub " },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Im unteren Twin Hub ",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 Einzelmatratzen mit Trennwand ",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gehe in unseren Kimonos zu den Duschen ",
            },
            { src: "women_s_bathroom.jpg", alt: "Damenbadezimmer " },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Kostenlose Rituals-Pflegeprodukte ",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrenbadezimmer " },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Entspanne in unserem Hot Tub auf dem Dach ",
            },
          ],
        },
        movieHub: {
          title: "Movie Hub",
          excerpt: "Private Hub mit Kingsize-Bett und großem Fernseher. ",
          description:
            "Dieses winzige Zimmer für bis zu 2 Reisende verfügt über ein Kingsize-Bett und einen großen Fernseher. Ideal für Binge-Watching direkt aus dem Bett. ",
          imagePath: "/assets/images/accomodation/movieHub_RKV/",
          images: [
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Entspanne in deinem Kingsize-Bett ",
            },
            {
              src: "large_tv_for_your_favourite_shows.jpg",
              alt: "Großer Fernseher für deine Lieblingsserien ",
            },
            { src: "women_s_bathroom.jpg", alt: "Damenbadezimmer " },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Kostenlose Rituals-Pflegeprodukte ",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrenbadezimmer " },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Entspanne in unserem Hot Tub auf dem Dach ",
            },
          ],
        },
        howManyTravellers: {
          title: "Wie viele Reisende?",
          content:
            'Alle unsere Unterkünfte bieten gemütliche Betten, stimmungsvolles Licht und einen Hauch von Technik. Die einzige Frage ist: Wie übernachtest du am liebsten? <ul className="list-disc p-4"><li>Allein oder als Paar unterwegs und Lust auf Privatsphäre? → Wähle einen Hub.</li><li>Zusammen reisen, aber getrennte Betten bevorzugt (Freunde/Kollegen)? → Ein Twin Hub ist perfekt.</li><li>Auf der Suche nach einem traditionelleren Zimmer mit großem Fernseher (Gemeinschaftsbad)? → Wähle einen Movie Hub.</li></ul>Egal, wofür du dich entscheidest, du wirst gut schlafen.<br />Wähle 1 oder 2 Gäste, um den Preis zu sehen. ',
        },
        addAnotherAccomodation: {
          title: "Weitere Unterkunft hinzufügen",
          hub: {
            title: "Hub",
            description:
              "Private Hub mit Kingsize-Bett – perfekt für einen oder zwei Reisende.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Private Hub mit 2 Einzelbetten und Trennwand – ideal für Freunde oder Geschwister. ",
          },
          movieHub: {
            title: "Movie Hub",
            description:
              "Kompaktes Privatzimmer mit Kingsize-Bett und Fernseher – perfekt für bis zu zwei Personen. ",
          },
        },
      },
      RTM: {
        tags: [],
        hub: {
          title: "Hub",
          excerpt:
            "Dein eigener privater Hub für bis zu 2 Reisende mit einem Kingsize-Bett. Perfekt für Alleinreisende, Freunde oder Paare, die Wert auf Komfort legen.",
          description:
            "Dein eigener privater Hub für bis zu 2 Reisende mit einem Kingsize-Bett. Perfekt für Alleinreisende, Freunde oder Paare, die Wert auf Komfort legen.",
          imagePath: "/assets/images/accomodation/hub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Unser Hub ist eine L-förmige Kapsel ",
            },
            { src: "see_the_top_hub.jpg", alt: "Oberen Hub ansehen " },
            { src: "inside_the_top_hub.jpg", alt: "Im oberen Hub " },
            { src: "see_the_bottom_hub.jpg", alt: "Unteren Hub ansehen " },
            { src: "inside_the_bottom_hub.jpg", alt: "Im unteren Hub " },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Entspanne in deinem Kingsize-Bett ",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Ja, du kannst im Bett aufrecht sitzen ",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gehe in unseren Kimonos zu den Duschen ",
            },
            { src: "women_s_bathroom.jpg", alt: "Damenbadezimmer " },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Erfrische dich unter der Regendusche ",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrenbadezimmer " },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Kostenlose Rituals-Pflegeprodukte ",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          excerpt:
            "Gleiche Größe wie ein Hub, aber in 2 Einzelmatratzen mit getrennten Decken und einer Trennwand unterteilt. Ideal für 2 Personen, die ihren eigenen Bereich wollen. Toll für Freunde oder Geschwister. ",
          description:
            "Gleiche Größe wie ein Hub, aber in 2 Einzelmatratzen mit getrennten Decken und einer Trennwand unterteilt. Ideal für 2 Personen, die ihren eigenen Bereich wollen. Toll für Freunde oder Geschwister. ",
          imagePath: "/assets/images/accomodation/twinHub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Unser Hub ist eine L-förmige Kapsel ",
            },
            {
              src: "inside_the_bottom_twin_hub.png",
              alt: "Im unteren Twin Hub ",
            },
            {
              src: "relax_in_your_king_size_bed.png",
              alt: "Entspanne in deinem Kingsize-Bett ",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Gehe in unseren Kimonos zu den Duschen ",
            },
            { src: "women_s_bathroom.jpg", alt: "Damenbadezimmer " },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Erfrische dich unter der Regendusche ",
            },
            { src: "men_s_bathroom.jpg", alt: "Herrenbadezimmer " },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Kostenlose Rituals-Pflegeprodukte ",
            },
          ],
        },
        howManyTravellers: {
          title: "Wie viele Reisende?",
          content:
            'Alle unsere Unterkünfte bieten gemütliche Betten, stimmungsvolles Licht und einen Hauch von Technik. Die einzige Frage ist: Wie übernachtest du am liebsten? <ul className="list-disc p-4"><li>Allein oder als Paar unterwegs und Lust auf Privatsphäre? → Wähle einen Hub.</li><li>Zusammen reisen, aber getrennte Betten bevorzugt (Freunde/Kollegen)? → Ein Twin Hub ist perfekt.</li></ul>Egal, wofür du dich entscheidest, du wirst gut schlafen.<br />Wähle 1 oder 2 Gäste, um den Preis zu sehen. ',
        },
        addAnotherAccomodation: {
          title: "Weitere Unterkunft hinzufügen",
          hub: {
            title: "Hub",
            description:
              "Private Hub mit Kingsize-Bett – perfekt für einen oder zwei Reisende.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Private Hub mit zwei Einzelbetten und Trennwand – ideal für Freunde oder Geschwister. ",
          },
        },
      },
      tags: {
        hub: [
          "Private Hub für 1-2 Personen",
          "1 Kingsize-Bett",
          "Gemeinschaftsbäder",
          "Rituals-Pflegeprodukte",
          "Handtücher",
          "Kimonos",
        ],
        twinHub: [
          "Private Hub für 2 Personen",
          "2 Einzelmatratzen mit Trennwand",
          "Gemeinschaftsbäder",
          "Rituals-Pflegeprodukte",
          "Handtücher",
          "Kimonos",
        ],
        room: [
          "20m² Zimmer für 1-4 Personen",
          "4 Etagenbetten oder 2 Etagenbetten & Doppelbett",
          "Privates Badezimmer",
          "Rituals-Pflegeprodukte",
          "Handtücher",
          "Kimonos",
          "Barrierefreier Zugang",
        ],
        movieHub: [
          "Private Hub für 1-2 Personen",
          "1 Kingsize-Bett",
          "Gemeinschaftsbäder",
          "Rituals-Pflegeprodukte",
          "Handtücher",
          "Kimonos",
          "Fernseher",
        ],
      },
      faq: {
        hub: [
          {
            q: "Oberer oder unterer Hub? Kann ich wählen?",
            a: "Ja. Ein Hub ist deine eigene private Hub in L-Form, gemacht für 2 Personen. Hubs sind paarweise gestapelt: einer oben, einer unten. Beim Check-in entscheidest du mit deinem CityHost, ob du lieber kletterst oder abtauchst. ",
          },
          {
            q: "Erzähl mir mehr über diesen Hub.",
            a: "Dein 6 m² großer Hub ist mit cleverem Stauraum, Steckdosen und WLAN ausgestattet. Die Betten sind bereits bezogen. Über die CityHub-App kannst du das Licht deiner Stimmung anpassen. Inklusive Bluetooth-Musikstreaming. ",
          },
          {
            q: "Gibt es eine Klimaanlage im Hub?",
            a: "Ja, dein Hub ist an ein zentrales Klimasystem angeschlossen, das auf die angenehmste Temperatur für den Durchschnittsreisenden eingestellt ist. ",
          },
          {
            q: "Was kann ich von den Badezimmern erwarten?",
            a: "Ziemlich luxuriös. Gemeinschaftlich genutzt, aber nach Geschlechtern getrennt, ausgestattet mit Regenduschen und kostenlosen Pflegeprodukten. Wir halten sie den ganzen Tag über super sauber. ",
          },
          {
            q: "Muss ich meine eigenen Handtücher mitbringen?",
            a: "Wir haben alles für dich da. Handtücher, Rituals-Pflegeprodukte, Shampoo, Haartrockner und ja, sogar ein Bügeleisen. Hast du schon von unseren speziellen CityHub-Kimonos gehört? Sehr praktisch für den Weg zur Dusche. Bring aber bitte deine eigenen Flip-Flops mit. ",
          },
          {
            q: "Kann ich mit Kindern kommen?",
            a: "Wir lieben Kinder, wirklich. Leider sind unsere Gemeinschaftseinrichtungen nicht für Babys oder Kleinkinder unter 6 Jahren geeignet. Bitte beachte, dass ein Hub maximal für 2 Personen Platz bietet, Kinder eingeschlossen. ",
          },
        ],
        twinHub: [
          {
            q: "Oberer oder unterer Hub? Kann ich wählen?",
            a: "Japp. Ein Hub ist deine eigene private Hub in L-Form, gemacht für 2 Personen. Hubs sind paarweise gestapelt: einer oben, einer unten. Beim Check-in entscheidest du mit deinem CityHost, ob du lieber kletterst oder abtauchst. ",
          },
          {
            q: "Erzähl mir mehr über diesen Hub.",
            a: "Dein 6m² großer Hub ist mit cleverem Stauraum, Steckdosen und WLAN ausgestattet. Die Betten sind bereits bezogen. Über die CityHub-App kannst du das Licht deiner Stimmung anpassen. Inklusive Bluetooth-Musikstreaming. ",
          },
          {
            q: "Gibt es eine Klimaanlage im Hub?",
            a: "Ja, dein Hub ist an ein zentrales Klimasystem angeschlossen, das auf die angenehmste Temperatur für den Durchschnittsreisenden eingestellt ist. ",
          },
          {
            q: "Was kann ich von den Badezimmern erwarten?",
            a: "Ziemlich luxuriös. Gemeinschaftlich genutzt, aber nach Geschlechtern getrennt, ausgestattet mit Regenduschen und kostenlosen Pflegeprodukten. Wir halten sie den ganzen Tag über super sauber. ",
          },
          {
            q: "Muss ich meine eigenen Handtücher mitbringen?",
            a: "Wir haben alles für dich da. Handtücher, Rituals-Pflegeprodukte, Shampoo, Haartrockner und ja, sogar ein Bügeleisen. Hast du schon von unseren speziellen CityHub-Kimonos gehört? Sehr praktisch für den Weg zur Dusche. Bring aber bitte deine eigenen Flip-Flops mit. ",
          },
          {
            q: "Kann ich mit Kindern kommen?",
            a: "Wir lieben Kinder, wirklich. Leider sind unsere Gemeinschaftseinrichtungen nicht für Babys oder Kleinkinder unter 6 Jahren geeignet. Bitte beachte, dass ein Hub maximal für 2 Personen Platz bietet, Kinder eingeschlossen. ",
          },
        ],
        room: [
          {
            q: "Erzähl mir mehr über dieses Room.",
            a: "Dein Room  verfügt über ein eigenes Badezimmer und ist mit Steckdosen und WLAN ausgestattet. Die Betten sind bezogen. Mit der CityHub-App kannst du das Licht deiner Stimmung anpassen. Inklusive Bluetooth-Musikstreaming. ",
          },
          {
            q: "Gibt es eine Klimaanlage im Room?",
            a: "Ja, dein Room  ist an ein zentrales Klimasystem angeschlossen, das auf die angenehmste Temperatur für den Durchschnittsreisenden eingestellt ist. ",
          },
          {
            q: "Muss ich meine eigenen Handtücher mitbringen?",
            a: "Wir haben alles für dich da. Handtücher, Rituals-Pflegeprodukte, Shampoo, Haartrockner und ja, sogar ein Bügeleisen. Hast du schon von unseren speziellen CityHub-Kimonos gehört? Sehr praktisch für den Weg zur Dusche. Bring aber bitte deine eigenen Flip-Flops mit. ",
          },
          {
            q: "Kann ich mit Kindern kommen?",
            a: "Wir lieben Kinder, wirklich. Leider sind unsere Gemeinschaftseinrichtungen nicht für Babys oder Kleinkinder unter 6 Jahren geeignet. Bitte beachte, dass ein Room maximal für 4 Personen Platz bietet, Kinder eingeschlossen. ",
          },
        ],
        movieHub: [
          {
            q: "Erzähl mir mehr über diesen Movie Hub.",
            a: "Dein Movie Hub ist mit cleverem Stauraum, Steckdosen, WLAN und einem großen Fernseher ausgestattet. Die Betten sind bereits bezogen. Über die CityHub-App kannst du das Licht deiner Stimmung anpassen. Inklusive Bluetooth-Musikstreaming. ",
          },
          {
            q: "Gibt es eine Klimaanlage im Movie Hub?",
            a: "Ja, dein Movie Hub ist an ein zentrales Klimasystem angeschlossen, das auf die angenehmste Temperatur für den Durchschnittsreisenden eingestellt ist. ",
          },
          {
            q: "Was kann ich von den Badezimmern erwarten?",
            a: "Ziemlich luxuriös. Gemeinschaftlich genutzt, aber nach Geschlechtern getrennt, ausgestattet mit Regenduschen und kostenlosen Pflegeprodukten. Wir halten sie den ganzen Tag über super sauber. ",
          },
          {
            q: "Muss ich meine eigenen Handtücher mitbringen?",
            a: "Wir haben alles für dich da. Handtücher, Rituals-Pflegeprodukte, Shampoo, Haartrockner und ja, sogar ein Bügeleisen. Hast du schon von unseren speziellen CityHub-Kimonos gehört? Sehr praktisch für den Weg zur Dusche. Bring aber bitte deine eigenen Flip-Flops mit. ",
          },
          {
            q: "Kann ich mit Kindern kommen?",
            a: "Wir lieben Kinder, wirklich. Leider sind unsere Gemeinschaftseinrichtungen nicht für Babys oder sehr junge Kinder unter 6 Jahren geeignet. Bitte beachten Sie: Ein Quad Room ist für maximal 4 Personen geeignet. Kinder sind dabei eingeschlossen.",
          },
        ],
      },
    },
    modal: {
      selectHotel: {
        title: "Stadt wählen",
        button: {
          label: "Stadt wählen",
        },
      },
      selectCulture: {
        title: "Sprache & Währung",
        button: {
          label: "Änderungen speichern",
        },
      },
      uspBar: {
        title: "Bestpreisgarantie",
        content:
          "Wir garantieren dir, dass du bei Buchung über unsere Website immer den bestmöglichen Preis erhältst.",
      },
    },
    component: {
      uspBar: {
        title: "Bestpreisgarantie",
      },
    },
    scenes: {
      traveller_one: "Reisender",
      traveller_other: "Reisende",
      night_one: "Nacht",
      night_other: "Nächte",
      selectHotel: {
        chooseCity: "Lass uns zusammen buchen, wähle deine Stadt",
      },
      accommodation: {
        pricePerNight: "Preis pro Nacht",
        pricePerNightInclVat: "Preis pro Nacht (inkl. MwSt.)",
        remove: "Entfernen",
        directBookingDiscount: "Direktbuchungs-Rabatt",
        notAvailable: "nicht verfügbar",
        unavailable: "Nicht verfügbar",
        noMoreRoomsAvailable: "Jetzt buchen · letzte Hub",
        addAnotherRoom: "Weiteres Zimmer hinzufügen",
        addAnotherHub: "Weiteren Hub hinzufügen",
        howManyTravellers: "Wie viele Reisende?",
        questions: "FAQs",
        moreTags_one: "weiteres Tag",
        moreTags_other: "weitere Tags",
        more_info: "mehr Infos",
        not_available: "An diesem Datum nicht verfügbar",
        show_more: "Mehr Informationen",
        show_less: "Weniger Informationen",
        selected: "ausgewählt",
      },
      calendar: {
        startNotice: "{{hotelName}} öffnet seine Türen am {{startDate}}",
      },
      extras: {
        perPersonPerNight: "pro Person, pro Nacht",
        add: "Hinzufügen",
        remove: "Entfernen",
        moreInfo: "Mehr Infos",
      },
      summary: {
        perNight: "/ Nacht",
        checkIn: "CHECK-IN",
        checkOut: "CHECK-OUT",
        rate: "Tarif:",
        discount: "Rabatt:",
        from: "Von",
        before: "Vor",
        total: "Gesamt",
        incCityTax: "Kurtaxe",
        incVat: "Inkl. MwSt.",
        incVatRooms: "Inkl. MwSt. Zimmer",
        incVatProducts: "Inkl. MwSt. Produkte",
        directBookingDiscount: "Direktbuchungs-Rabatt",
        voucher: "Gutschein",
        addVoucher: "Gutschein hinzufügen",
        voucherInvalid: "Dieser Gutscheincode ist nicht korrekt",
        voucherNotApplicable: "Dieser Gutschein gilt nicht für den gewählten Tarif",
      },
      details: {
        firstName: "Vorname",
        firstNameRequired: "Vorname ist erforderlich",
        lastName: "Nachname",
        lastNameRequired: "Nachname ist erforderlich",
        email: "E-Mail-Adresse",
        emailRequired: "E-Mail-Adresse ist erforderlich",
        emailInvalid:
          "E-Mail ist erforderlich und sollte ein @ und mindestens einen Punkt enthalten",
        phoneMin: "Die Telefonnummer sollte mindestens 9 Ziffern enthalten",
        phoneInvalid: "Die Telefonnummer sollte numerisch sein",
        countryRequired: "Land ist ein Pflichtfeld",
        phone: "Telefonnummer",
        country: "Land",
        selectCountry: "Wähle dein Land",
        specialRequests: "Besondere Wünsche",
        terms:
          "Ich stimme den <firstLink>AGB</firstLink> und den <secondLink>Datenschutzbestimmungen</secondLink> der Unterkunft zu.",
        marketingEmails: "Ich möchte gelegentlich Marketing-Updates erhalten.",
        createReservation: "Reservierung erstellen",
        finishPaymentAtKiosk: "Schließe deine Zahlung an unserem Kiosk ab.",
        creatingReservation: "Deine Reservierung wird erstellt...",
        reservationCreated: "Reservierung erstellt!",
        somethingWentWrong:
          "Etwas ist schiefgelaufen, bitte versuche es erneut.",
      },
      payment: {
        paymentMethods: "Zahlungsmethoden",
        paymentMethodsDescription:
          "Nur noch ein letzter Schritt. Schließe deine Zahlung unten sicher ab. Wir verwenden verschlüsselte Zahlungsmethoden, um deine Daten zu schützen. Nach erfolgreicher Zahlung erhältst du eine Bestätigungs-E-Mail.",
        authorizeCreditCard: "Autorisiere deine Kreditkarte",
        cardChargeInfo:
          "Deine Karte wird 48 Stunden vor dem Anreisetag belastet",
        securedWithMews: "Gesichert mit Mews Payments via PCI Proxy",
        payWithCreditCard: "Mit Kreditkarte bezahlen",
        payDirectly: "Direkt bezahlen",
        onlyVisaAndMastercardSupported:
          "Es werden nur Visa und MasterCard unterstützt",
        nameOnCreditCard: "Name auf der Kreditkarte",
        cardNumber: "Kartennummer",
        expirationDate: "Ablaufdatum",
        expirationDateRequired: "Ablaufdatum ist erforderlich",
        yearCanNotBeInThePast:
          "Das Jahr darf nicht in der Vergangenheit liegen",
        yearCanNotBeMoreThan5YearsInTheFuture:
          "Das Jahr darf nicht mehr als 5 Jahre in der Zukunft liegen",
        monthCanNotBeInThePast:
          "Der Monat darf nicht in der Vergangenheit liegen",
        monthCanNotBeBiggerThan12: "Der Monat darf nicht größer als 12 sein",
        shouldBeAMonthAndAYear: "Sollte ein Monat und ein Jahr sein MM/JJJJ",
        validateCard: "Karte validieren",
        createReservation: "Reservierung erstellen",
        nameIsRequired: "Name ist erforderlich",
        cardNumberIsRequired: "Kartennummer ist erforderlich",
        invalidCardNumber: "Ungültige Kartennummer",
        cvcIsRequired: "CVC ist erforderlich",
        invalidCvc: "Ungültiger CVC",
        somethingWentWrong:
          "Etwas ist schiefgelaufen. Bitte versuche es später erneut.",
        somethingWentWrong4501:
          "Etwas ist schiefgelaufen (4501). Bitte versuche es später erneut.",
        creatingReservation: "Deine Reservierung wird erstellt...",
        reservationCreated: "Reservierung erstellt!",
        finishPayment: "Deine Zahlung wird abgeschlossen...",
        creditcardNotAuthorizable: "Kreditkarte nicht autorisierbar",
      },
      success: {
        bookingConfirmed: "Buchung bestätigt!",
        bookingConfirmedDescription:
          "Dein Aufenthalt im {{hotelName}} ist unter Dach und Fach. <br/>Check-in ab 15:00 Uhr. Bis bald 👋",
        startChatting: "Chat starten",
        viewBookingDetails: "Buchungsdetails anzeigen",
        bookingDetails: "Buchungsdetails",
        whatsNext: "Wie geht's weiter?",
        connectWithHost:
          "Verbinde dich mit deinem CityHost, deinem persönlichen 24/7-Ansprechpartner für Tipps, Wegbeschreibungen und lokale Geheimnisse.",
        online: "ONLINE",
      },
      pageNotFound: {
        message:
          "Hoppla! <br />Wir können die Seite, die du suchst, nicht finden.",
        linkText: "Wähle dein Hotel, um zu beginnen",
      },
      redirectHotel: {
        message: "Hotelkonfiguration wird geladen...",
      },
      redirectPayment: {
        error4602: "[error" + ":4602] Keine Reservierung gefunden",
        noPaymentsFound: "Keine Zahlungen gefunden",
        paymentSuccessful: "Zahlung erfolgreich",
        paymentFailed: "Zahlung fehlgeschlagen",
        returningToSite: "Rückkehr zur Website...",
        authorizationPending: "Autorisierung ausstehend",
        authorizationPendingMessage:
          "Deine Reservierung wurde erstellt, aber die Autorisierung steht noch aus.<br /><br />Klicke hier, um deine Karte zu autorisieren.",
      },
    },
    form: {
      language: {
        label: "Sprache",
        placeholder: "Sprache auswählen",
        options: {
          "en-US": "Englisch",
          "nl-NL": "Niederländisch",
          "de-DE": "Deutsch",
        },
        validation: { required: "Sprache ist ein Pflichtfeld" },
      },
      currency: {
        label: "Währung",
        placeholder: "Währung auswählen",
        options: {
          EUR: "Euro (€)",
          USD: "US-Dollar ($)",
          GBP: "Britisches Pfund (£)",
          CAD: "Kanadischer Dollar (C$)",
          DKK: "Dänische Krone (DKK)",
          ISK: "Isländische Krone (ISK)",
        },
        validation: { required: "Währung ist ein Pflichtfeld" },
      },
    },
  },
};
